import * as React from "react";
import { observe } from "mobx";
export class StakeInput extends React.Component {
    constructor(props) {
        super(props);
        this.getInputValue = e => {
            var procValue = this.props.inputHandler(e.target.value);
            this.setState({
                value: procValue
            }, () => {
                this.props.handler(this.state.value);
            });
        };
        this.state = {
            value: props.provider.stakeValue
        };
        this.disposeValue = observe(this.props.provider, "stakeValue", o => {
            this.setState({
                value: o.newValue
            });
        });
    }
    componentWillUnmount() {
        this.disposeValue();
    }
    render() {
        return (React.createElement("input", { type: this.props.type, inputMode: "decimal", className: "rj-yourbet__stake-input", "data-uat": "stakebox", value: this.state.value, onChange: this.getInputValue, disabled: this.props.disabled }));
    }
}
//# sourceMappingURL=StakeInput.js.map